import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import "./PrivacySettings.scss"
import { PARTICIPANT_VIDEO_VISIBILITY } from "../../Constants/Texts"
import { updateProfile } from "../../services/CallApi"
import { ErrorUI } from "../../components/UI/Modals/Modals"
import { profileActions } from "../../store"
import { CheckboxUIs } from "../../components/UI/FormInput/FormInput"

const PrivacySettings = ({ ...props }) => {
  const { participant_video_visibility, is_profile_public } = useSelector(
    (state) => state.profile.profileData
  )
  const dispatch = useDispatch()
  const change = (data) => {
    updateProfile({ participant_video_visibility: data }).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data))
      } else {
        ErrorUI(res.list, () => {
          change(data)
        })
      }
    })
  }

  const changePublic = (isPublic) => {
    updateProfile({ is_profile_public: isPublic }).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data))
      } else {
        ErrorUI(res.list, () => {
          changePublic(isPublic)
        })
      }
    })
  }

  return (
    <div className="PrivacySettings">
      <div className="PrivacySettingsDetailBox">
        <div className="PrivacySettingsToggleBox">
          <p className="SharePerformanceText">Share my performance data:</p>
          <CheckboxUIs
            value={is_profile_public}
            change={(e) => {
              if (e.target.checked) {
                changePublic(true)
              } else {
                ErrorUI(
                  "Are you sure? Then your coaches won’t be able to advise you in real time.",
                  () => {
                    changePublic(false)
                  },
                  {
                    cancelText: "Cancel",
                    submitText: "Yes",
                  }
                )
              }
            }}
            disabled={false}
          />
        </div>
        <p className="ShowMyHeartText">
          Show my heart rate during the workout to my coach and my classmates
          (people I’m doing activities with)
        </p>
        <p className="SharePerformanceText">Share my workout videos with:</p>
        <div className="PrivacySettingsRadioButtonBox">
          <div
            className="PrivacySettingsRadioButton"
            onClick={() => change(PARTICIPANT_VIDEO_VISIBILITY.ALL)}
          >
            <label>All</label>
            <input
              type="radio"
              id="All"
              name="All"
              value={PARTICIPANT_VIDEO_VISIBILITY.ALL}
              checked={
                participant_video_visibility ===
                PARTICIPANT_VIDEO_VISIBILITY.ALL
              }
            />
          </div>
          <hr className="lineBreaker" />
          <div
            className="PrivacySettingsRadioButton"
            onClick={() => change(PARTICIPANT_VIDEO_VISIBILITY.COACH_ONLY)}
          >
            <label>Coach</label>
            <input
              type="radio"
              id="Coach"
              name="Coach"
              value={PARTICIPANT_VIDEO_VISIBILITY.COACH_ONLY}
              checked={
                participant_video_visibility ===
                PARTICIPANT_VIDEO_VISIBILITY.COACH_ONLY
              }
            />
          </div>
          <hr className="lineBreaker" />
          <div
            className="PrivacySettingsRadioButton"
            onClick={() => change(PARTICIPANT_VIDEO_VISIBILITY.NONE)}
          >
            <label>None</label>
            <input
              type="radio"
              id="None"
              name="None"
              value={PARTICIPANT_VIDEO_VISIBILITY.NONE}
              checked={
                participant_video_visibility ===
                PARTICIPANT_VIDEO_VISIBILITY.NONE
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacySettings
